/*
 *
 * Auth reducer
 *
 */
import {
  AUTH_AUTHENTICATE_SUCCESS,
  AUTH_CLEAR_USER_INFO,
  AUTH_ERROR,
  AUTH_FORGOT_PASSWORD,
  AUTH_FETCH_BY_TOKEN,
  AUTH_FETCHED_BY_TOKEN,
  AUTH_RESET_PASSWORD,
  AUTH_SIGN_IN,
  AUTH_SIGN_UP,
  AUTH_SIGN_OUT,
  AUTH_UPDATE_PASSWORD,
  AUTH_USER_CONFIRMATION_TOKEN_EXPIRED,
  AUTH_USER_CONFIRMATION_TOKEN_VALIDATED,
  AUTH_USER_CONFIRMATION_REQUEST_ERROR,
  AUTH_USER_CONFIRMATION_REQUEST_SUCCESS,
  AUTH_LINK_GOOGLE_REQUEST_SUCCESS,
  AUTH_LINK_GOOGLE_REQUEST_ERROR,
  AUTH_LINK_FACEBOOK_REQUEST_SUCCESS,
  AUTH_LINK_FACEBOOK_REQUEST_ERROR,
  AUTH_UNLINK_GOOGLE_REQUEST_SUCCESS,
  AUTH_UNLINK_GOOGLE_REQUEST_ERROR,
  AUTH_UNLINK_FACEBOOK_REQUEST_SUCCESS,
  AUTH_UNLINK_FACEBOOK_REQUEST_ERROR,
  AUTH_USER_ACTIVATION_REQUEST_ERROR,
  AUTH_USER_ACTIVATION_REQUEST_SUCCESS,
} from '../../actions/auth/types';

const initialState = {
  user: null,
  isAuthenticated: false,
  isCheckedAuth: false,
  recover: {
    emailSent: false,
    isValidToken: false,
    completed: false,
  },
  confirmation: {
    emailSent: false,
    isValidToken: false,
    waitingTokenValidate: true,
  },
  userData: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_FORGOT_PASSWORD:
    case AUTH_RESET_PASSWORD:
    case AUTH_UPDATE_PASSWORD:
      return { ...state, recover: action.payload };
    case AUTH_USER_CONFIRMATION_REQUEST_ERROR:
    case AUTH_USER_CONFIRMATION_REQUEST_SUCCESS:
    case AUTH_USER_CONFIRMATION_TOKEN_EXPIRED:
    case AUTH_USER_CONFIRMATION_TOKEN_VALIDATED:
      return { ...state, confirmation: action.payload };
    case AUTH_SIGN_IN:
    case AUTH_SIGN_UP:
    case AUTH_FETCH_BY_TOKEN:
      return {
        ...state,
        user: action.payload.user,
        isAuthenticated: !!action.payload.user,
        isCheckedAuth: true,
      };
    case AUTH_FETCHED_BY_TOKEN:
    case AUTH_AUTHENTICATE_SUCCESS:
      return { ...state, isAuthenticated: true };
    case AUTH_SIGN_OUT:
      return { ...state };
    case AUTH_ERROR:
    case AUTH_CLEAR_USER_INFO:
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        isCheckedAuth: true,
        ...action.payload,
      };
    case AUTH_LINK_GOOGLE_REQUEST_SUCCESS:
    case AUTH_LINK_GOOGLE_REQUEST_ERROR:
    case AUTH_LINK_FACEBOOK_REQUEST_SUCCESS:
    case AUTH_LINK_FACEBOOK_REQUEST_ERROR:
    case AUTH_UNLINK_GOOGLE_REQUEST_SUCCESS:
    case AUTH_UNLINK_GOOGLE_REQUEST_ERROR:
    case AUTH_UNLINK_FACEBOOK_REQUEST_SUCCESS:
    case AUTH_UNLINK_FACEBOOK_REQUEST_ERROR:
    case AUTH_USER_ACTIVATION_REQUEST_ERROR:
    case AUTH_USER_ACTIVATION_REQUEST_SUCCESS:
      return { ...state, userData: action.payload };
    default:
      return initialState;
  }
}

export { reducer, initialState };
